/* eslint-disable */
import React from "react";

import GeneralPageContext from "../../templates/GeneralPageContext";

import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";

import source from "../../../translation";

const suppressWarn =
    process.env.GATSBY_SUPPRESS_TEMPLATE_TEXT_WARNING === "TRUE";

const translate = (...args) => {
    const { locale } = React.useContext(GeneralPageContext);
    if (args.length === 0) {
        return "";
    }

    const id = `${args[0].raw ? args[0].raw[0] : args[0]}${locale ? `-${locale}` : ""}`;

    if (source[id] === undefined || source[id] === null) {
        if (!suppressWarn) console.warn(`translation key "${id}" not found`);
        return id;
    }

    let res = source[id];
    let className = "";

    for (let i = 1; i < args.length; i++) {
        // replace variables
        if (Array.isArray(args[i]) && typeof res !== "object") {
            args[i].forEach((v) => {
                res = res.replace(/%v/, v.raw ? v.raw[0] : v);
            });
        } else if (typeof args[i] === "string") {
            className = args[i];
        }
    }

    if (typeof res === "object") {
        return (
            <StructuredTextRenderer
                className={className}
                data={res}
                contentElementType={"TemplateText"}
            />
        );
    }

    return res;
};

export default translate;
